import * as toolsService from "../../services/Tools/toolsService";
import {gridsNames} from "../../enums/gridsNames";
import * as gridActionsHelper from "../../../../infrastructure/js/components/Grid/Utils/gridActionsHelper";
import DateTimeHelper from "infrastructure/js/utils/dateTimeHelper";

const gridActions = gridActionsHelper.getGridActions(gridsNames.PREDEFINED_LIST_ACTIVE_TOOLS, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function(dispatch, getState) {
    return toolsService.fetchActiveTools(query);
  }
};

function _convertToRowData(rows, serverTimeSeconds){
  let items = rows.map((obj) => {
    obj.cyclesCount = (obj.maxNumOfCycles !== null) ? (obj.maxNumOfCycles - (obj.maxNumOfCycles - obj.currentCyclesNumber)) : null;
    obj.m_maintenanceUsageTime = DateTimeHelper.ConvertMinutesToDaysHoursMinutes(obj.maintenanceUsageTime);
    obj.m_maintenanceRemainingUsageTime = DateTimeHelper.ConvertMinutesToDaysHoursMinutes(obj.maintenanceRemainingUsageTime);
    if (obj.lastOperation) {
      obj.lastOperation.m_time =
        obj.lastOperation.createdDate ? DateTimeHelper.FormatDateObjectToRelativeTime(obj.lastOperation.createdDate, serverTimeSeconds) : null;
    }

    obj.m_maintenanceData = _createMaintenanceData(obj);

    return obj;
  });
  return items;
};


/**
 * @param {import('../../types/ServerTypes/Models/Data.js').ToolResponseModel} tool
 */
function _createMaintenanceData(tool) {

  let type = tool.toolType.maintenanceType;

  // Temporary workaround for server logic having default TIME_BASED type for no maintenance tools.
  if (type === "TIME_BASED" && tool.maintenanceIntervalTime === null) {
    type = null;
  }

  return {

    type: type,

    timeBased: {

      elapsedMinutes: tool.maintenanceIntervalTime,
      remainingMinutes: tool.maintenanceRemainingIntervalTime,
      totalMinutes: tool.maintenanceIntervalTime + tool.maintenanceRemainingIntervalTime,

      percentRemaining: 100 - _calculatePercentUsed(tool.maintenanceIntervalTime, tool.maintenanceRemainingIntervalTime),

      nextMaintenanceDate: tool.nextMaintenanceDueDate

    },

      usageBased: {

          remainingMinutes: tool.maintenanceRemainingUsageTime,
          completedMinutes: tool.completedUsageTime,
          startedMinutes: tool.startedUsageTime,
          scheduledMinutes: tool.scheduledUsageTime,

          elapsedMinutes: tool.maxManufactureUsageTime - tool.maintenanceRemainingUsageTime,
          totalMinutes: tool.maxManufactureUsageTime,
          percentRemaining: 100 - _calculatePercentUsed(tool.maxManufactureUsageTime - tool.maintenanceRemainingUsageTime, tool.maintenanceRemainingUsageTime),

          nextMaintenanceDate: tool.nextMaintenanceDueDate

        },


        cycleBased: {

          remainingCycles: tool.maintenanceRemainingCycles,
          completedCycles: tool.completedCyclesNumber,
          startedCycles: tool.startedCyclesNumber,
          scheduledCycles: tool.scheduledCyclesNumber,

          elapsedCycles: tool.maxNumOfCycles - tool.maintenanceRemainingCycles,
          totalCycles: tool.maxNumOfCycles,

          percentRemaining: 100 - _calculatePercentUsed(tool.maxNumOfCycles - tool.maintenanceRemainingCycles, tool.maintenanceRemainingCycles),

          nextMaintenanceDate: tool.nextMaintenanceDueDate

        }


  };

}


/**
 * @param {number} elapsed
 * @param {number} remaining
 */
function _calculatePercentUsed(elapsed, remaining) {
  let total = elapsed + remaining;
  if (total === 0) {
    return 0;
  }

  if (remaining === 0) {
    return 100;
  }

  let percentExact = (elapsed / total) * 100;
  let percentRounded = Math.round(percentExact);

  // Ensure at least 1% is shown if there is any usage
  if (percentRounded === 0 && percentExact > 0) {
    return 1;
  }

  return percentRounded;
}

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
